
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const PencilIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m10.04 17.885 10.28-10.28a2 2 0 0 0 0-2.828l-1.122-1.123a2 2 0 0 0-2.828 0L6.09 13.935a2.016 2.016 0 0 0-.364.497l-2.63 5.096c-.446.865.481 1.793 1.346 1.348l5.1-2.626c.184-.096.352-.218.498-.365Z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5.91 14.19 3.88 3.88M18 21H4.04"/></svg> </SvgIcon>
);
